// core
import { Injectable, Inject } from '@angular/core';

// Datadog
import { datadogLogs } from '@datadog/browser-logs';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  initiationSettings: any;

  constructor(@Inject('environment') private environment: any) { }

  initiateLogging(service: string) {
    this.initiationSettings = {
      clientToken: this.environment.datadogClientToken,
      site: 'datadoghq.com',
      sessionSampleRate: 100
    };

    this.initiationSettings.service = service;

    // For production, forwarding console.error logs, uncaught exceptions and network errors to Datadog
    this.initiationSettings.forwardErrorsToLogs = this.environment.production;

    if (this.environment.logger) {
      datadogLogs.init(this.initiationSettings);
    }
  }

  // Use this to log info
  info(eventClass: string, eventMethod: string, logData?: any, eventName?: string) {
    if (this.environment.logger) {
      datadogLogs.logger.info(`${eventClass} ${eventMethod}${eventName ? ' ' + eventName : ''}`, { log_data: logData });
    }
  }

  // Use this to log warning
  warn(eventClass: string, eventMethod: string, logData: any, eventName?: string) {
    if (this.environment.logger) {
      datadogLogs.logger.warn(`${eventClass} ${eventMethod}${eventName ? ' ' + eventName : ''}`, { log_data: logData });
    }
  }

  // Use this to log errors
  // Good to use in catch blocks
  error(eventClass: string, eventMethod: string, logData: any, eventName?: string) {
    if (this.environment.logger) {
      datadogLogs.logger.error(`${eventClass} ${eventMethod}${eventName ? ' ' + eventName : ''} failure`, { log_data: logData });
    }
  }
}
